import React, { useState } from "react";
import { useSettings } from "../useData";
import { toast } from "sonner";
import { api } from "../api";
import SEO from "../components/SEO";
import Newsletter from "../components/Newsletter";

const Contact = () => {
  const artist = useSettings();
  const [form, setForm] = useState({ name: "", email: "", subject: "General", message: "" });
  const [sending, setSending] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.sendContact(form);
      toast("Message sent — Alice will reply within 3 working days.");
      setForm({ name: "", email: "", subject: "General", message: "" });
    } catch (err) {
      toast.error("Could not send message. Please try again or email directly.");
    } finally {
      setSending(false);
    }
  };

  if (!artist) return null;

  return (
    <div className="px-6 md:px-10 max-w-[900px] mx-auto pb-24">
      <SEO
        title="Contact"
        description="Get in touch with Alice Lisi for editorial commissions, exhibitions, prints and press. Studio in Milano, Italy."
        path="/contact"
      />
      <div className="pt-2 pb-12">
        <span className="font-serif italic text-[color:var(--ink-mute)]">Contact</span>
      </div>

      <p className="font-serif italic text-3xl md:text-4xl leading-[1.25] max-w-2xl">
        Editorial commissions, exhibitions, prints and other kind requests — always welcome.
      </p>

      <div className="grid grid-cols-12 gap-8 md:gap-16 mt-20 border-t border-[color:var(--line)] pt-10">
        {/* Info column */}
        <div className="col-span-12 md:col-span-4 space-y-8">
          <div>
            <p className="font-serif italic text-[color:var(--ink-mute)] mb-2">Studio</p>
            <p className="font-serif">{artist.location || "Milano, Italy"}</p>
          </div>

          <div>
            <p className="font-serif italic text-[color:var(--ink-mute)] mb-2">Direct</p>
            <a href={`tel:${(artist.phone || "").replace(/\s/g, "")}`} className="font-serif tlink block">
              {artist.phone}
            </a>
            <a href={`mailto:${artist.email}`} className="font-serif tlink block mt-1">
              {artist.email}
            </a>
            <a href={artist.instagramUrl} target="_blank" rel="noreferrer" className="font-serif tlink block mt-1">
              {artist.instagram}
            </a>
          </div>

          <div>
            <p className="font-serif italic text-[color:var(--ink-mute)] mb-2">Representation</p>
            <p className="font-serif">Maison de la Photographie</p>
            <p className="font-serif text-[color:var(--ink-mute)]">Paris, France</p>
          </div>
        </div>

        {/* Contact form */}
        <form onSubmit={onSubmit} className="col-span-12 md:col-span-8 space-y-5">
          <label className="block">
            <span className="font-serif italic text-[color:var(--ink-mute)]">Name</span>
            <input required name="name" value={form.name} onChange={onChange} className="mt-1 w-full bg-transparent border-b border-[color:var(--ink)] py-2 outline-none font-serif text-xl" />
          </label>
          <label className="block">
            <span className="font-serif italic text-[color:var(--ink-mute)]">Email</span>
            <input required type="email" name="email" value={form.email} onChange={onChange} className="mt-1 w-full bg-transparent border-b border-[color:var(--ink)] py-2 outline-none font-serif text-xl" />
          </label>
          <label className="block">
            <span className="font-serif italic text-[color:var(--ink-mute)]">Subject</span>
            <select name="subject" value={form.subject} onChange={onChange} className="mt-1 w-full bg-transparent border-b border-[color:var(--ink)] py-2 outline-none font-serif text-xl">
              <option>General</option>
              <option>Editorial commission</option>
              <option>Exhibition</option>
              <option>Print sales</option>
              <option>Press</option>
            </select>
          </label>
          <label className="block">
            <span className="font-serif italic text-[color:var(--ink-mute)]">Message</span>
            <textarea required rows={5} name="message" value={form.message} onChange={onChange} className="mt-1 w-full bg-transparent border-b border-[color:var(--ink)] py-2 outline-none resize-none font-serif text-xl" />
          </label>
          <div className="flex items-center justify-between pt-4">
            <p className="font-serif italic text-[color:var(--ink-mute)]">Reply within 3 days</p>
            <button
              type="submit"
              disabled={sending}
              className="btn-sober disabled:opacity-50"
              data-testid="contact-submit-button"
            >
              {sending ? "Sending…" : "Send message"}
            </button>
          </div>
        </form>
      </div>

      {/* Newsletter */}
      <div className="mt-24">
        <Newsletter source="contact" />
      </div>
    </div>
  );
};

export default Contact;
